module.exports = __webpack_public_path__ + "img/SmartPhoneHelp.28738e4f.png";